// Detects scripts / code pasted into free-text ticket fields (subject,
// description): HTML/XML tags, JavaScript, SQL, template and shell injection.
//
// The rules look for CODE-LIKE SHAPES, not single words, so normal sentences
// such as "please select an option from the menu" or "update my number" pass.

const SCRIPT_PATTERNS = [
  // ---- HTML / XML / script tags (also <?xml, <!DOCTYPE, <![CDATA[, <?php) ----
  /<\/?[a-z!?]/i,
  // ---- JavaScript ----
  /\b(?:javascript|vbscript)\s*:|data\s*:\s*text\/html/i,
  /\bon(?:error|load|click|mouseover|mouseout|focus|blur|submit|change|keydown|keyup)\s*=/i,
  /\b(?:eval|alert|prompt)\(|document\s*\.\s*(?:cookie|write|location)|window\s*\.\s*location/i,
  // ---- template / expression injection ----
  /<%|\{\{[\s\S]*?\}\}|\$\{[\s\S]*?\}/,
  // ---- SQL ----
  /\bunion\b\s+(?:all\s+)?select\b/i,
  /\bselect\b\s+\*\s+from\b/i,
  /\bselect\b\s+[\w.`"]+(?:\s*,\s*[\w.`"]+)*\s+from\s+[\w.`"]+\s*(?:;|$|\bwhere\b|\bjoin\b|\blimit\b|\border\s+by\b|\bgroup\s+by\b)/i,
  /\binsert\s+into\s+[\w.`"]+\s*(?:\(|values\b|select\b)/i,
  /\bupdate\s+[\w.`"]+\s+set\s+[\w.`"]+\s*=/i,
  /\bdelete\s+from\s+[\w.`"]+\s*(?:;|$|\bwhere\b)/i,
  /\bdrop\s+(?:table|database|schema|view|index|column)\b/i,
  /\b(?:truncate|alter)\s+table\b/i,
  /;\s*(?:drop|delete|truncate|alter|insert|update|select|exec|shutdown)\b/i,
  /\b(?:or|and)\s+['"]?\d+['"]?\s*=\s*['"]?\d+/i,
  /['"]\s*(?:--|#|\/\*)/,
  /\/\*[\s\S]*?\*\//,
  /\b(?:xp_cmdshell|information_schema|load_file\s*\(|benchmark\s*\(|waitfor\s+delay)\b|\bsleep\s*\(\s*\d+/i,
  /\bexec(?:ute)?\s*\(|\bexec\s+(?:sp_|xp_)/i,
  // ---- shell ----
  /\$\([^)]*\)/,
  /(?:;|&&|\|\|)\s*(?:rm|curl|wget|chmod|bash|sh|nc|cat|ls)\s/i,
];

// Also catches encoded variants: %3Cscript%3E, &lt;script&gt;, &#60;script ...
const normalize = (text) => {
  let t = String(text || "");
  try {
    t = decodeURIComponent(t);
  } catch (_e) {
    /* not URL-encoded text: keep as is */
  }
  return t.replace(/&lt;|&#0*60;|&#x0*3c;/gi, "<");
};

export const containsScript = (text) => {
  const t = normalize(text);
  return SCRIPT_PATTERNS.some((re) => re.test(t));
};

// fields: { Subject: subject, Description: description }
// Returns "" when everything is fine, otherwise a message for the user.
export const findScriptInTicketFields = (fields) => {
  for (const [label, value] of Object.entries(fields)) {
    if (containsScript(value)) {
      return `You can't add scripts or code (SQL, HTML, XML, JavaScript, etc.) in the ${label.toLowerCase()}. Please describe your issue in plain words.`;
    }
  }
  return "";
};
